export default __webpack_public_path__ + "static/media/file.57e885a5.svg";